import palette from '@lib/core/src/theme/palette';
import { styled, AppBar, Stack, IconButton } from '@mui/material';

export const HEADER_HEIGHT = '52px';
export const BREAKPOINT_SMALL = 'md';

export const HeaderContainer = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  borderBottom: `1px solid ${palette.grey[1200]}`,
  backgroundColor: palette.globalBackground,
  flexDirection: 'row',
  alignItems: 'center',
  padding: '0 1vw',
  height: HEADER_HEIGHT,
  zIndex: theme.zIndex.drawer + 1,
  justifyContent: 'space-between'
}));

export const ButtonsRowReverse = styled(Stack)({
  gap: '16px',
  flexDirection: 'row-reverse',
  alignItems: 'center'
});

export const CompanyLogo = styled(IconButton)({
  backgroundColor: 'transparent',
  padding: '1px',
  height: '29px',
  width: '70px',
  maxWidth: '70px',
  borderRadius: '24px',
  mb: { md: 1, lg: 3 },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const CompanyImg = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block'
});

export const JourneyLogoContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  [theme.breakpoints.down(BREAKPOINT_SMALL)]: {
    justifyContent: 'center'
  }
}));

export const MenuIconContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  display: 'none',
  width: '70px',
  maxWidth: '70px',
  [theme.breakpoints.down(BREAKPOINT_SMALL)]: {
    display: 'flex'
  }
}));

export const IntegrationsContainer = styled(IconButton)(({ theme }) => ({
  padding: '3px',
  borderRadius: '24px',
  [theme.breakpoints.down(BREAKPOINT_SMALL)]: {
    display: 'none'
  }
}));

export const AddUserIcon = styled(IconButton)(({ theme }) => ({
  fontSize: '12px',
  borderRadius: '24px',
  color: palette.grey[500],
  [theme.breakpoints.down(BREAKPOINT_SMALL)]: {
    display: 'none'
  }
}));
